import {
  Avatar,
  AvatarGroup,
  Box,
  HStack,
  Icon,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";

import { FaStar, FaFacebook } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

import { REVIEW_SOURCE_URLS } from "#app/components/ReviewCard.jsx";
import { useLocale } from "#app/context/LocaleContext.jsx";

/**
 * Social proof bar: avatars + rating on top, then a line of context with the
 * review sources as outbound links so people can go read them. Shared by the
 * search hero (HomeHero) and the single-facility hero (FacilityHero).
 */
export function ReviewProof({ reviews = [], stats }) {
  const locale = useLocale();
  if (!stats?.total) return null;
  const faces = reviews.filter((r) => r.reviewerName).slice(0, 5);

  return (
    <VStack spacing={1.5}>
      <HStack spacing={3} flexWrap="wrap" justify="center">
        {faces.length > 0 && (
          <AvatarGroup size="sm" max={5} spacing="-0.6rem">
            {faces.map((r) => (
              <Avatar key={r.id} name={r.reviewerName} src={r.reviewerAvatar} />
            ))}
          </AvatarGroup>
        )}
        <HStack spacing={1}>
          <HStack spacing={0.5} aria-hidden="true">
            {[1, 2, 3, 4, 5].map((i) => (
              <Box key={i} as={FaStar} color="warning" boxSize="16px" />
            ))}
          </HStack>
          {stats.avgGoogleRating && (
            <Text fontWeight="extrabold" fontSize="md">
              {stats.avgGoogleRating}
            </Text>
          )}
        </HStack>
      </HStack>

      <Text fontSize="sm" color="muted">
        Rated by {stats.total.toLocaleString(locale)} campers on{" "}
        <Link
          href={REVIEW_SOURCE_URLS.google}
          isExternal
          fontWeight="semibold"
          color="emphasized"
        >
          <Icon as={FcGoogle} boxSize="14px" verticalAlign="-2px" mr="1" />
          Google
        </Link>{" "}
        &amp;{" "}
        <Link
          href={REVIEW_SOURCE_URLS.facebook}
          isExternal
          fontWeight="semibold"
          color="emphasized"
        >
          <Icon
            as={FaFacebook}
            color="#1877F2"
            boxSize="14px"
            verticalAlign="-2px"
            mr="1"
          />
          Facebook
        </Link>
      </Text>
    </VStack>
  );
}
